import React, { useCallback } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Header from '../ui/Header';
import { useAuth } from '../../contexts/AuthContext';

const DashboardLayout = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = useCallback(() => {
    try {
      if (logout) {
        logout();
      }
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    } finally {
      navigate('/login', { replace: true });
    }
  }, [logout, navigate]);

  return (
    <div className="min-h-screen bg-background">
      <Header isAuthenticated={Boolean(user)} onLogout={handleLogout} />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
